<template>
  <div class="pt-150">
    <galerie/>
  </div>
</template>

<script>
import galerie from "@/views/myComponent/galerie";

export default {
  name: "home",
  components: {
    galerie
  },
  data: function () {
    return {
    };
  },
  methods: {
  }
};
</script>
<style scoped>
.image {
  float: left;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  border: 1px solid #ebebeb;
  margin: 5px;
}
</style>
